// src/app/page.tsx
import { FC, useState } from "react";
import { Box, Paper, Typography, useTheme } from "@mui/material";
import { drawerWidth } from "../../constants";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import Grid from "@mui/material/Grid2";
import ExpandIcon from "../../assets/images/Expand.svg";
import MagicIcon from "../../assets/images/AI-Magic.svg";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import "./index.css";
import { CustomButton } from "../../components/Button";
import { useNavigate } from "react-router-dom";
import { ConfirmationDialog } from "../../components/ConfirmationDialog";
import DoneAllRoundedIcon from "@mui/icons-material/DoneAllRounded";
import MemoryImg from "../../assets/images/Memory-green.svg";
import PastMemories from "./PastMemories";

const ManageMemory: FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [showInputMemory, setShowInputMemory] = useState(false);
  const [newInput, setNewInput] = useState("");
  const [generatedMemory, setGeneratedMemory] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationProps, setConfirmationProps] = useState({
    title: "",
    content: "",
    btn1: "",
    btn2: "",
    handleBtn1: () => {},
    handleBtn2: () => {},
    icon: <div></div>,
  });

  const updateMemory = () => {
    setConfirmationProps({
      title: "BO Memory Updated",
      content:
        "Don’t worry you can always turn things around. Would you like to proceed or feed more?",
      btn1: "Close",
      btn2: "Feed more",
      handleBtn1: () => setShowConfirmation(false),
      handleBtn2: () => {},
      icon: (
        <div>
          <DoneAllRoundedIcon />
        </div>
      ),
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: { sm: `calc(100% - ${drawerWidth + 90}px)` },
        ml: { sm: `${drawerWidth}px` },
        justifyContent: "center",
        alignItems: "center",
        margin: "10px",
        // height: "100vh",
      }}
      className="page-container"
    >
      <Typography
        className="page-head"
        sx={{ display: { xs: "none", sm: "block" } }}
      >
        {showInputMemory ? "Memory Wizard" : "Manage Memory"}
      </Typography>
      <div className="page-content">
        <Grid container sx={{ width: "100%" }}>
          <Grid size={{ xs: 6, md: 6 }}>
            <Typography>Current Memory</Typography>
          </Grid>
          <Grid size={{ xs: 6, md: 6 }} display={"flex"} justifyContent={"end"}>
            <AutoFixHighIcon
              color="secondary"
              onClick={() => setShowInputMemory(true)}
              className="c-pointer"
            />
          </Grid>
        </Grid>
        <div className="memory-box">
          <textarea
            className="personality-textarea"
            placeholder="This bot acts as my HR. Facilitates employee onboarding, manages HR queries, and helps with scheduling and feedback collection."
            style={{ backgroundColor: theme.palette.background.default }}
          ></textarea>
          <div className="expand">
            <img src={ExpandIcon} />
          </div>
        </div>

        {!showInputMemory ? (
          <PastMemories
            setShowConfirmation={(val) => {
              setShowConfirmation(val);
              setConfirmationProps({
                title: "Old Memory",
                content:
                  "This is the old memory text box. I let Bo know everything.",
                btn1: "Close",
                btn2: "Restore memory",
                handleBtn1: () => setShowConfirmation(false),
                handleBtn2: () => {},
                icon: (
                  <div>
                    <img src={MemoryImg} />
                  </div>
                ),
              });
            }}
          />
        ) : (
          <div className="newmemory-section">
            <Typography>Your input</Typography>
            <div className="memory-box">
              <textarea
                className="personality-textarea"
                placeholder="Here you can feed your new memory to BO"
                style={{ backgroundColor: theme.palette.background.default }}
                onChange={(e) => setNewInput(e.target.value)}
                value={newInput}
              ></textarea>
              <div className="expand">
                <img src={ExpandIcon} />
              </div>
            </div>
            <Box
              className="justify-center mt-5"
              sx={{
                width: { xs: "100%", sm: "40%" },
                margin: "0 auto",
              }}
            >
              <CustomButton
                text={"Generate new memory"}
                endIcon={<img src={MagicIcon} className="magic-icon" />}
                bgcolor={
                  newInput
                    ? "rgba(180, 69, 52, 1)"
                    : theme.palette.background.default
                }
                color={
                  newInput
                    ? theme.palette.background.default
                    : "rgba(33, 143, 84, 1)"
                }
                submit={() => {
                  setGeneratedMemory(newInput);
                  setNewInput("");
                }}
                // border="1px solid rgba(33, 143, 84, 1)"
                fontWeight="bold"
                borderRadius="8px"
                width="100%"
                disabled={!newInput}
              />
            </Box>
          </div>
        )}
        {generatedMemory && showInputMemory ? (
          <div className="newmemory-section">
            <Typography>Generated memory</Typography>
            <div className="memory-box">
              <textarea
                className="personality-textarea"
                placeholder="Here you can feed your new memory to BO"
                style={{ backgroundColor: theme.palette.background.default }}
                value={newInput}
              ></textarea>
              <div className="expand">
                <img src={ExpandIcon} />
              </div>
            </div>
          </div>
        ) : null}
        <div className="btns">
          <CustomButton
            text={showInputMemory ? "View past memories" : "Back to chat"}
            submit={() =>
              showInputMemory ? setShowInputMemory(false) : navigate("/chat")
            }
            bgcolor={theme.palette.background.default}
            color="rgba(33, 143, 84, 1)"
            border="1px solid rgba(33, 143, 84, 1)"
            fontWeight="bold"
            borderRadius="8px"
            width="40%"
          />
          <CustomButton
            text={"Update Memory"}
            // submit={() => navigate("/chat")}
            bgcolor="rgba(33, 143, 84, 1)"
            color={theme.palette.background.default}
            border={`1px solid ${theme.palette.background.default}`}
            fontWeight="bold"
            borderRadius="8px"
            width="40%"
            submit={() => {
              setShowConfirmation(true);
              setConfirmationProps({
                title: "Current Memory",
                content: "Are you sure you want to update BO Memory?",
                btn1: "Never mind",
                btn2: "Yes please",
                handleBtn1: () => setShowConfirmation(false),
                handleBtn2: () => updateMemory(),
                icon: <div></div>,
              });
            }}
          />
        </div>
      </div>
      {showConfirmation ? (
        <ConfirmationDialog
          open={showConfirmation}
          content={confirmationProps.content}
          title={confirmationProps.title}
          btn1={confirmationProps.btn1}
          btn2={confirmationProps.btn2}
          handleBtn1={confirmationProps.handleBtn1}
          handleBtn2={confirmationProps.handleBtn2}
          icon={confirmationProps.icon}
        />
      ) : null}
    </Box>
  );
};

export default ManageMemory;
